<template>
 <div class='homeBanner'>
    <el-carousel trigger="click">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <div class="b_item">
          <img class="itemImg" :src="item.imgUrl" alt="">
          <div class="h5qrcode_box" v-if="index==0">
              <div class="app_qrcode_wrap" >
                <div id="bannerAppQrcode">

                </div>
              </div>
              <span class="txt">扫码下载咚咚燕APP</span>
          </div>
        </div>
        
      </el-carousel-item>
      <img :src="imgHeight" class="toolImg itemImg" alt="">
    </el-carousel>
 </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
    name:'homeBanner',
    props: {
    },
    data () {
        return {
          imgList: [
            {
              imgUrl: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/banner_ddymh.png',
            },
          ],
          imgHeight: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/banner_ddymh.png',
          bannerAppQrcode: null
        };
    },

    methods: {
      async bannerAppQrcodeFn() {
        if (this.bannerAppQrcode) return;
        this.bannerAppQrcode = new QRCode("bannerAppQrcode", {
          width: 82,
          height: 82, // 高度
          text: `${location.origin}/appDownload`, // 二维码内容
          display: "none"
          // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f',   // 背景色
          // foreground: '#ff0'    // 前景色
        });
      }
    },

    mounted(){
      this.$nextTick(() => {
          this.bannerAppQrcodeFn()
      })
    },
}

</script>
<style lang='stylus' scoped>
    @import "../../asset/css/homeBanner.styl"
</style>
<style lang='stylus'>
    // 兼容谷歌
.homeBanner {
  /deep/.el-carousel__indicators .el-carousel__indicators--horizontal {
    bottom: 80px!important;
  }
  .el-carousel__container{
    height: auto!important;
    .itemImg {
      width: 130%!important;
      margin-left: -18%;
    }
  }
  /deep/.el-carousel__indicators--horizontal {
    bottom: 23px;
    // display: none;
    .el-carousel__indicator--horizontal {
      padding: 12px 10px;
      .el-carousel__button {
        width: 9px;
        height: 9px;
        border-radius: 50%;
      }
    }
  }
  // 兼容火狐
  @-moz-document url-prefix() {
    .el-carousel__container{
      height: auto!important;
      .itemImg {
        width: 130%!important;
        margin-left:-18%;
      }
    }
    .el-carousel__indicators--horizontal {
      bottom: 23px;
      // display: none;
      .el-carousel__indicator--horizontal {
        padding: 12px 10px;
        .el-carousel__button {
          width: 9px;
          height: 9px;
          border-radius: 50%;
        }
      }
    }
  }
  // 兼容IE
  .el-carousel__container{
    height: auto!important;
    .itemImg {
      width: 130%!important;
      margin-left:-18%;
    }
  }
  .el-carousel__indicators--horizontal {
    bottom: 23px;
    // display: none;
    .el-carousel__indicator--horizontal {
      padding: 12px 10px;
      .el-carousel__button {
        width: 9px;
        height: 9px;
        border-radius: 50%;
      }
    }
  }

.b_item{
  position:relative;
  .h5qrcode_box{
    position:absolute;
    left:50%;
    bottom:26px;
    margin-left -38%;
    display: flex;
    flex-direction: column;
    align-items: center;
      .app_qrcode_wrap{
        width:98px;
        height:98px;
        border-radius:6px;
        background-color:#fff;
        margin-bottom:10px;
        display:flex;
        align-items:center;
        justify-content:center;
      }
      .txt{
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        font-size:14px;
        color:#3a3a3a;
      }
  }
}
  

}
</style>
